import React from 'react';
import { FileCategoriesBlock } from '../../_blocks/Categories';
import { Icons } from '../../components/atoms/SVG';
import { WidgetType } from '../../types/api/ElementType';
import { ContextWidget } from '../../types/api/Widget';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type FileCategoriesWidget = ContextWidget<FileCategoriesBlock, WidgetType.filecategories>;

export function FileCategoriesWidget(props: FileCategoriesWidget) {
  const { t } = useSonTranslation('Categories');
  return <DefaultContextWidget icon={Icons.CATEGORIES} title={t('widget.headline')} {...props} />;
}
